export enum EMessageType {
  UNDEFINED,
  INFORMATION,
  WARNING,
  ERROR,
  UPDATE,
  SUPPORT_FILE,
}
